// extracted by mini-css-extract-plugin
export default {"ReportsPage":"reports_ReportsPage__PoVbp"};